export const styles = {
  container: 'tw-flex tw-items-center tw-gap-4 tw-shrink-0',
  supportedPimsSelect: 'tw-min-w-[160px] tw-max-w-[250px]',
  checkboxLabel:
    'tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-neutral-700 tw-whitespace-nowrap tw-cursor-pointer tw-select-none',
  checkbox: 'tw-cursor-pointer',
  selectElement: 'tw-w-full',
};
